/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react';

import {
  CLICK_DIRECTIONS,
  FETCH_OPTIONS,
} from '../../../constants';
import { getDateTime } from '../../../utils/common';

export default class SelectableTable extends Component {
  constructor() {
    super();
    this.state = {
      selectedRows: [],
      clickActive: false,
      selectedIndex: null,
      direction: null,
      multipleSelection: false,
      startIndex: null,
    };
  }

  componentDidMount() {
    this.tableView = document.getElementById('table-view');
    if (this.tableView) {
      this.prevScrollTop = this.tableView.scrollTop;
      this.tableView.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    this.tableView.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if ((!this.props.isFetching[FETCH_OPTIONS.GET_EVENTS]
      && !this.props.isFetching[FETCH_OPTIONS.GET_TENNIS_EVENTS])
      && this.tableView.scrollHeight
      <= Math.ceil(this.tableView.offsetHeight + this.tableView.scrollTop)
      && this.prevScrollTop !== this.tableView.scrollTop
      && this.props.lastDate
      && this.props.lastEventId) {
      this.props.loadMore();
    }
    this.prevScrollTop = this.tableView.scrollTop;
  };

  select=(rows, r, isReset) => {
    rows.push(r.index);
    this.props.onChange(rows, r, true, isReset);
    return rows;
  };

  unselect=(rows, index, r) => {
    rows.splice(index, 1);
    this.props.onChange(rows, r, false);
    return rows;
  };

  resetSelections=() => {
    this.props.onResetSelections();
    return [];
  };

  startSelection=(event, e) => {
    if (e.button !== 2 && e.target.classList[0] !== 'context-menu__list-item') {
      let selectedRows = this.state.selectedIndex !== event.index && !e.ctrlKey
        ? [] : this.state.selectedRows;
      if (this.state.selectedRows.length > 0 && (e.ctrlKey
        || (this.state.selectedIndex !== event.index))) {
        const index = selectedRows.findIndex((s) => s === event.index);
        if (index === -1) {
          selectedRows = this.select(selectedRows, event, selectedRows.length === 0);
        } else {
          selectedRows = this.unselect(selectedRows, index, event);
        }
      } else {
        selectedRows = this.select(selectedRows, event, true);
      }

      this.setState({
        selectedRows,
        clickActive: true,
        selectedIndex: event.index,
        direction: null,
        startIndex: event.index,
        multipleSelection: false,
      });
    }
  };

  middleSelection=(event, e) => {
    if (this.state.clickActive && this.state.selectedIndex !== event.index && e.button !== 2) {
      let selectedRows = this.state.selectedRows;
      if ((this.state.direction === CLICK_DIRECTIONS.UP && this.state.selectedIndex < event.index)
      || (this.state.direction === CLICK_DIRECTIONS.DOWN
         && this.state.selectedIndex > event.index)) {
        const i = selectedRows.findIndex((s) => s === this.state.selectedIndex);
        selectedRows = this.unselect(selectedRows, i, this.props.rows[this.state.selectedIndex]);
      }
      const index = selectedRows.findIndex((s) => s === event.index);

      if (index === -1) {
        selectedRows = this.select(selectedRows, event);
      }
      const direction = !this.state.direction
        ? this.state.selectedIndex - event.index
        : this.state.startIndex === event.index
          ? null : this.state.direction;

      this.setState({
        direction,
        selectedIndex: event.index,
        multipleSelection: true,
      });
    }
  };

  endSelection=(e) => {
    if (this.state.clickActive && e.button !== 2) {
      let selectedRows = this.state.selectedRows;
      if (!this.state.multipleSelection
        && selectedRows.filter((r) => r === this.state.startIndex).length > 1) {
        selectedRows = this.resetSelections();
      }
      this.setState({
        selectedRows,
        clickActive: false,
      });
    }
  };

  renderRow=(rowInfo, date, time) => (
    <tr
      className={`${this.props.getClassName(rowInfo)} ${this.state.selectedRows.find((s) => s === rowInfo.index) !== undefined
         && 'table-style__row--selected'}`}
      key={rowInfo.index}
      onMouseDown={this.startSelection.bind(this, rowInfo)}
      onMouseOver={this.middleSelection.bind(this, rowInfo)}
      onMouseUp={this.endSelection}
      onContextMenu={this.props.openMenu.bind(this, rowInfo)}
    >
      {this.props.renderRow(rowInfo, date, time)}
    </tr>
  );

  renderEvents=(event, timezone) => {
    const currentTime = new Date().toLocaleString('en-GB', { timeZone: timezone });
    const currentHour = currentTime.split(' ')[1].split(':')[0];

    const dateTime = getDateTime(event.startDateTime, timezone);
    const dateTimeArr = dateTime.split(' ');
    const date = dateTimeArr[0];
    const dateArr = date.split('/');
    const formattedDate = `${dateArr[0]}/${dateArr[1]}`;
    const time = dateTimeArr[1];
    const timeArr = time.split(':');
    const formattedTime = `${timeArr[0]}:${timeArr[1]}`;

    const eventHour = parseInt(timeArr[0]);

    if (eventHour === this.props.timeHeaders[this.timeIndex]) {
      return (
        this.renderRow(event, formattedDate, formattedTime)
      );
    }
    this.timeIndex += 1;
    return (
      <React.Fragment key={`hour-${this.timeIndex}`}>
        <tr
          className={`table-style__row table-style__row--time ${timeArr[0] !== currentHour && 'black'} `}
          key={`hour-${this.timeIndex}`}
          onMouseUp={this.endSelection}
        >
          <td className="text-left p-l-20" colSpan="10">
            {this.props.timeHeaders[this.timeIndex]?.toString().length < 2
              ? `0${this.props.timeHeaders[this.timeIndex]}`
              : this.props.timeHeaders[this.timeIndex]}
            :00
          </td>
        </tr>
        {this.renderRow(event, formattedDate, formattedTime)}
      </React.Fragment>
    );
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  clearSelectedRows = () => {
    this.setState({
      selectedRows: [],
    });
  };

  /**
   * Render
   *
   * @function
   * @returns {view}
   */
  render() {
    this.timeIndex = 0;
    const method = this.props.eventsTable ? this.renderEvents : this.renderRow;
    return (
      <div className="table-wrapper m-t-30">
        <div
          className="table-responsive fix-15"
          id="table-view"
        >
          <table
            className="table-style table-style--event"
            onMouseLeave={this.endSelection}
          >
            <thead
              onMouseUp={this.endSelection}
            >
              <tr>
                {this.props.headers.map((h) => <th key={h}>{h}</th>)}
                <th className="menu" />
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, index) => method({...row, index}, this.props.timezone))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

